// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xScreen } from "@adl/XDL/Utilities";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
/**
 * We don't use TypographyPresentationProps, because we need to inject style by css
 */
interface OrderInformationStyles {
    label?: StyledProp<any>;
    value?: StyledProp<any>;
    labelWithDots?: StyledProp<any>;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    address?: any;
    orderSummary?: any;
}
const xOrderInformationStyles: OrderInformationStyles = {
    label: css`
        font-weight: bold;
        font-size: 15px;
        margin-right: 8px;
        line-height: 26px;
        white-space: nowrap;
        @media print {
            font-size: 11px;
            width: 100%;
        }
    `,
    value: css`
        font-size: 15px;
        line-height: 26px;
        font-weight: normal;
        @media print {
            font-size: 11px;
            width: 100%;
        }
    `,
};
xOrderInformationStyles.labelWithDots = css`
    ${xOrderInformationStyles.label}
    &:after {
        content: ":";
    }
`;
xOrderInformationStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            ${xScreen("lte", "md")} {
                flex-direction: column;

                @media print {
                    flex-direction: column;
                }
            }
        `,
    },
    heading: {
        css: css`
            ${xOrderInformationStyles.label}
        `,
    },
    text: {
        css: css`
            ${xOrderInformationStyles.value}
        `,
    },
};
xOrderInformationStyles.address = {
    heading: {
        variant: "h5",
        css: css`
            margin-bottom: 12px;
        `,
    },
};
xOrderInformationStyles.orderSummary = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-bottom: 10px;
        }
    `,
};
export default xOrderInformationStyles;
